// extracted by mini-css-extract-plugin
export default {"notFound":"_404_notFound__a5efh","backBtn":"_404_backBtn__LyK7z"};